export const MEDIA_GRID_UNDER_SM = '599px';
export const MEDIA_GRID_MD = '900px';

/**
 * @constant {string}
 * @desc Prefix for grafana lazy load import monitoring.
 * **/
export const LAZY_LOAD_ERROR_PREFIX = 'lazy_load_import';
